import useLogger from '@/composables/useLogger'
import useFlashMessage from '@/composables/useFlashMessage'
const logger = useLogger('copyTextComposable')
const flash = useFlashMessage()

export default function useCopyText () {
  const copyToClipboard = (s) => {
    navigator.clipboard.writeText(s)
      .then(() => {
        flash({
          showClose: true,
          message: `Copied: ${s}`,
          type: 'mini',
          duration: 1000
        })
      })
      .catch(error => {
        logger.error('error copying to clipboard', error.message)
        flash({
          showClose: true,
          message: `Unable to copy: ${s}`,
          type: 'mini',
          duration: 3000
        })
      })
  }

  return copyToClipboard
}
